import api, { BASE_URL } from "../../api";

const PRODUCT_COLLECTION_BASE_URL = `${BASE_URL}/shop/admin/collections/`;

const listProductCollections = (context) => {
  return api(context)
    .get(PRODUCT_COLLECTION_BASE_URL + "?page_size=100")
    .then((response) => response.data);
};

const getProductCollection = (context, key) => {
  return api(context)
    .get(`${PRODUCT_COLLECTION_BASE_URL}${key}/`)
    .then(response => response.data);
};

const updateProductCollection = (context, productCollection) => {
  return api(context)
    .patch(
      `${PRODUCT_COLLECTION_BASE_URL}${productCollection.id}/update/`,
      productCollection
    )
    .then(response => response.data);
};

const insertProductCollection = (context, productCollection) => {
  return api(context)
    .post(PRODUCT_COLLECTION_BASE_URL, productCollection)
    .then(response => response.data);
};

export const productCollection = {
         BASE_URL: PRODUCT_COLLECTION_BASE_URL,
         list: listProductCollections,
         get: getProductCollection,
         update: updateProductCollection,
         insert: insertProductCollection
       };

export default productCollection;
